import * as api from '../../api/bespoke/apcoa';
import q from '../../query';
export const feeKey = (feeId) => `apcoa-fee-${feeId}`;
export const useFee = (feeId) => q.query(feeKey(feeId), () => (feeId ? api.getFee(feeId) : undefined), []);
export const DMRKey = (feeId, registrationNumber) => `apcoa-dmr-${feeId}-${registrationNumber}`;
export const useDMR = (feeId, registrationNumber) => q.query(DMRKey(feeId, registrationNumber), () => feeId && registrationNumber
    ? api.getDMR(feeId, registrationNumber)
    : null, []);
export const parkingLotKey = (parkingLotCode) => `apcoa-parking-lot-${parkingLotCode}`;
export const useParkingLot = (parkingLotCode) => q.query(parkingLotKey(parkingLotCode), () => api.getParkingLot(parkingLotCode), []);
//# sourceMappingURL=index.js.map